import script from "./IndexView.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexView.vue?vue&type=script&setup=true&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=ceb691a6&scoped=true&lang=scss"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceb691a6"]])

export default __exports__